function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 13.559055 16.000004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 13.473506,13.933237 c 0,0 -0.777444,-2.148301 -1.166187,-3.294064 -0.327386,-0.9411366 -1.575441,-1.3094136 -2.639337,-1.3094136 -1.841424,0 -3.334997,1.4935726 -3.334997,3.3349556 0,1.841424 1.493573,3.334997 3.334997,3.334997 H 12.0004 c 1.063938,0.02047 1.820958,-1.043471 1.473106,-2.066475 z",
    fill: "#171f37",
    style: {
      strokeWidth: 0.423745
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.89053503,15.876953 C 1.688489,16.204296 2.793318,15.610969 3.284354,14.690299 4.164132,13.053458 3.591272,12.173679 4.286891,10.516456 4.839327,9.2479344 5.800931,8.1839964 7.08992,7.5906694 c 1.227631,-0.572903 2.434752,-0.552436 2.700737,-0.531969 0.593327,0.0614 1.268522,0.102291 1.084362,-0.409211 0,0 0,0 0,-0.02047 L 8.931345,1.0434594 C 8.910875,0.96161937 8.869945,0.90024137 8.82901,0.81839937 8.78812,0.73655937 8.74719,0.67517837 8.706252,0.61379837 8.563068,0.42966037 8.378909,0.26598037 8.153858,0.16368037 7.949232,0.06138037 7.703714,3.729248e-7 7.458196,3.729248e-7 H 7.192212 6.844402 6.087382 c -0.08183,0 -0.16365,0 -0.245517,0.0204599970752 -0.163693,0.02046 -0.306876,0.08184 -0.450102,0.14322 -0.286451,0.14322 -0.511502,0.368281 -0.675195,0.654719 -0.04093,0.06138 -0.08182,0.143222 -0.102292,0.22506003 L 1.320212,10.414119 0.09262403,13.933234 c -0.286452,0.797953 0.122759,1.657265 0.797911,1.943716 z",
    fill: "#7f56d9",
    style: {
      strokeWidth: 0.423745
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.3ee355fcc8a19a76bf81182b0b104215.svg";
export { ForwardRef as ReactComponent };